import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'

import Spinner from '@/components/Spinner/Spinner'

import styles from './FilterPanel.module.scss'

type Props = {
  disabled: boolean
  onClick: () => void
}

const FilterPanelButtons = ({ disabled, onClick }: Props) => {
  const router = useRouter()
  const [loading, setLoading] = useState(false)

  const setLoadingTrue = () => setLoading(true)
  const setLoadingFalse = () => setLoading(false)

  useEffect(() => {
    router.events.on('routeChangeStart', setLoadingTrue)
    router.events.on('routeChangeComplete', setLoadingFalse)
    router.events.on('routeChangeError', setLoadingFalse)

    return () => {
      router.events.off('routeChangeStart', setLoadingTrue)
      router.events.off('routeChangeComplete', setLoadingFalse)
      router.events.off('routeChangeError', setLoadingFalse)
    }
  }, [])

  return (
    <div className={styles.submit}>
      <Button disabled={disabled || loading} onClick={onClick} variant='primary'>
        {loading ? <Spinner /> : 'Filter'}
      </Button>
    </div>
  )
}

export default FilterPanelButtons
